import styled from '@emotion/styled'

export const FieldWrapper = styled.div`
  flex: 1;
`

export const TextWrapper = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
`
